import styled from "styled-components";
import { COLORS } from "../../../../../../styles/constants.style";

export const BulkSummaryResultWrapper = styled.div`
  background-color: ${COLORS.cirrus_black1};
  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
      .title-container {
        display: flex;
        align-items: center;
      }
    }
    .form-header-right {
      text-align: right;
      .MuiButton-root {
        height: auto;
        padding-left: 4px;
      }
      svg {
        margin-right: 10px;
      }
    }
  }

  .activity-details-accordion {
    margin-top: 32px;
    .MuiCollapse-wrapper {
      margin-top: 8px;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-left: 16px;
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      padding: 2px 9px 4px 9px;
      border-radius: 7px;
      margin-left: 8px;

      &.processed {
        background-color: ${COLORS.cirrus_green1};
      }

      &.unprocessed {
        background-color: ${COLORS.cirrus_red};
      }
    }
  }
  .activity-details-accordion:last-child {
    margin-bottom: 32px;
  }
`;
